export * from './tyreinfo.component';



// WEBPACK FOOTER //
// ./src/app/landingpages/tyreinfo/index.ts